const ProjectConfig = {
  develop: {
    project: 'loverfans',
    acronym: 'LF',
    primary_color: '#DF3856',
    background_color: '#2d3237',
    promotion: true,
    isDevelop: true,
    redirect_new_frontend: false,
    resources: {
      component: 'LoverfansBanner',
      downloadResourceComponent: 'LoverfansDownloadResourceView',
      promotion_resources: true,
      normal_resources: true,
      downloadableResource: true
    },
    enable_resources: true,
    show_footer: true,
    show_imprint: 'https://loverfans.com/loverfans_imprint',
    enable_themes: true,
    enable_scat_modal: true,
    twitter_enabled: true,
    twitter: 'loverfans',
    instagram: 'loverfans',
    multicurrency: true,
    domains: {
      baseUrl: 'https://develop.loverfans.com',
      api: 'https://api.develop.loverfans.com/api',
      websocket: 'wss://ws.develop.loverfans.com'
    },
    payments: {
      darkfans_redirect: false,
      provider: 'commercegate'
    },
    specialOffer: {
      active: false,
      startDate: new Date(2024, 9, 30, 9, 0, 0),
      endDate: new Date(2024, 10, 5, 9, 0, 0),
      discount: 20
    },
    campaign: {
      name: 'san_valentine_2025',
      fileName: 'valentine',
      specialName: 'Happy Valentine’s Day',
      cookieModal: 'hiddenModalCampaignValentine',
      users: ['CpPrueba01', 'CpPrueba02', 'CpPrueba03', 'CpPrueba04', 'CpStarPrueba05', 'CpStarPrueba06', 'CpStarPrueba07', 'CpStarPrueba08', 'velasa'],
      // enero es el mes 00
      started: new Date(2025, 1, 11, 8, 0, 0),
      endDate: new Date(2025, 1, 18, 8, 0, 0),
      post: true,
      specialEnabled: true,
      titleBanner_es: '❤️ FELIZ SAN VALENTIN ❤️',
      titleBanner_en: '❤️ HAPPY VALENTINE’S DAY ❤️',
      descriptionBanner_es: 'Recibe un bono en tu wallet del 30% de tus suscripciones',
      descriptionBanner_en: 'Get a 30% bonus in your wallet on your new subscriptions',
      colorBgBanner: '#DF3856'
    },
    locales: {
      project: 'Loverfans',
      project_upper: 'LOVERFANS',
      site: 'develop.loverfans.com',
      contact_email: 'soporte@loverfans.com',
      contact_email_creator: 'stars@develop-loverfans.com',
      contact_email_financial: 'financial@artemisa3000.com',
      info_email: 'info@loverfans.com',
      payments_imprint: {
        company: 'Inet-Cash GmbH',
        address: 'Am Stadtbad 14',
        city: '59065 Hamm',
        country: 'Germany',
        contact: {
          phone: 'Tel: +49 (2381) 338-9860',
          fax: 'Fax: +49 (2381) 338-9861',
          email: 'Email: support@inet-cash.com'
        }
      }
    },
    yoti: {
      url: 'https://api.yoti.com/idverify/v1/web/index.html'
    },
    google: {
      oauth: {
        enabled: true,
        client_id:
          '6243420342-deqr1irso0eiou0t8jh39goctgaldceq.apps.googleusercontent.com'
      }
      /* analytics: {
        id: 'UA-153181968-1'
      } */
    },
    gtm: 'GTM-WZ49T7G',
    analytics: {
      ga: 'GTM-WZ49T7G'
    },
    showFooterImages: false
  },
  legacy: {
    project: 'loverfans',
    acronym: 'LF',
    primary_color: '#DF3856',
    background_color: '#2d3237',
    promotion: true,
    isDevelop: false,
    redirect_new_frontend: false,
    resources: {
      component: 'LoverfansBanner',
      downloadResourceComponent: 'LoverfansDownloadResourceView',
      promotion_resources: true,
      normal_resources: true,
      downloadableResource: true
    },
    enable_resources: true,
    show_footer: true,
    show_imprint: 'https://loverfans.com/loverfans_imprint',
    enable_themes: true,
    enable_scat_modal: true,
    twitter_enabled: true,
    twitter: 'loverfans',
    instagram: 'loverfans',
    multicurrency: false,
    domains: {
      baseUrl: 'https://loverfans.com',
      api: 'https://api.loverfans.com/api',
      websocket: 'wss://ws.loverfans.com'
    },
    payments: {
      provider: 'commercegate',
      backup: 'inetcash'
    },
    specialOffer: {
      active: false,
      startDate: new Date(2024, 9, 30, 9, 0, 0),
      endDate: new Date(2024, 10, 5, 9, 0, 0),
      discount: 20
    },
    campaign: {
      name: 'san_valentine_2025',
      fileName: 'valentine',
      specialName: 'Happy Valentine’s Day',
      cookieModal: 'hiddenModalCampaignValentine',
      users: ['CpPrueba01', 'CpPrueba02', 'CpPrueba03', 'CpPrueba04', 'CpStarPrueba05', 'CpStarPrueba06', 'CpStarPrueba07', 'CpStarPrueba08'],
      // enero es el mes 00
      started: new Date(2025, 1, 11, 8, 0, 0),
      endDate: new Date(2025, 1, 18, 8, 0, 0),
      post: true,
      specialEnabled: true,
      titleBanner_es: '❤️ FELIZ SAN VALENTIN ❤️',
      titleBanner_en: '❤️ HAPPY VALENTINE’S DAY ❤️',
      descriptionBanner_es: 'Recibe un bono en tu wallet del 30% de tus suscripciones',
      descriptionBanner_en: 'Get a 30% bonus in your wallet on your new subscriptions',
      colorBgBanner: '#DF3856'
    },
    locales: {
      project: 'Loverfans',
      project_upper: 'LOVERFANS',
      site: 'loverfans.com',
      contact_email: 'soporte@loverfans.com',
      contact_email_creator: 'stars@loverfans.com',
      contact_email_financial: 'financial@artemisa3000.com',
      info_email: 'info@loverfans.com',
      payments_imprint: {
        company: 'Inet-Cash GmbH',
        address: 'Am Stadtbad 14',
        city: '59065 Hamm',
        country: 'Germany',
        contact: {
          phone: 'Tel: +49 (2381) 338-9860',
          fax: 'Fax: +49 (2381) 338-9861',
          email: 'Email: support@inet-cash.com'
        }
      }
    },
    yoti: {
      url: 'https://api.yoti.com/idverify/v1/web/index.html'
    },
    google: {
      oauth: {
        enabled: false,
        client_id:
          '6243420342-deqr1irso0eiou0t8jh39goctgaldceq.apps.googleusercontent.com'
      },
      analytics: {
        id: 'G-VRCGT887VF'
      }
    },
    gtm: 'GTM-KLTN4DF',
    analytics: {
      ga: 'G-VRCGT887VF'
    },
    showFooterImages: false
  },
  loverfans: {
    project: 'loverfans',
    acronym: 'LF',
    primary_color: '#DF3856',
    background_color: '#2d3237',
    promotion: true,
    isDevelop: false,
    redirect_new_frontend: true,
    resources: {
      component: 'LoverfansBanner',
      downloadResourceComponent: 'LoverfansDownloadResourceView',
      promotion_resources: true,
      normal_resources: true,
      downloadableResource: true
    },
    enable_resources: true,
    show_footer: true,
    show_imprint: 'https://loverfans.com/loverfans_imprint',
    enable_themes: true,
    enable_scat_modal: true,
    twitter_enabled: true,
    twitter: 'loverfans',
    instagram: 'loverfans',
    multicurrency: false,
    domains: {
      baseUrl: 'https://loverfans.com',
      api: 'https://api.loverfans.com/api',
      websocket: 'wss://ws.loverfans.com'
    },
    payments: {
      provider: 'commercegate',
      backup: 'inetcash'
    },
    specialOffer: {
      active: false,
      startDate: new Date(2024, 9, 30, 9, 0, 0),
      endDate: new Date(2024, 10, 5, 9, 0, 0),
      discount: 20
    },
    campaign: {
      name: 'san_valentine_2025',
      fileName: 'valentine',
      specialName: 'Happy Valentine’s Day',
      cookieModal: 'hiddenModalCampaignValentine',
      users: ['CpPrueba01', 'CpPrueba02', 'CpPrueba03', 'CpPrueba04', 'CpStarPrueba05', 'CpStarPrueba06', 'CpStarPrueba07', 'CpStarPrueba08'],
      // enero es el mes 00
      started: new Date(2025, 1, 11, 8, 0, 0),
      endDate: new Date(2025, 1, 18, 8, 0, 0),
      post: true,
      specialEnabled: true,
      titleBanner_es: '❤️ FELIZ SAN VALENTIN ❤️',
      titleBanner_en: '❤️ HAPPY VALENTINE’S DAY ❤️',
      descriptionBanner_es: 'Recibe un bono en tu wallet del 30% de tus suscripciones',
      descriptionBanner_en: 'Get a 30% bonus in your wallet on your new subscriptions',
      colorBgBanner: '#DF3856'
    },
    locales: {
      project: 'Loverfans',
      project_upper: 'LOVERFANS',
      site: 'loverfans.com',
      contact_email: 'soporte@loverfans.com',
      contact_email_creator: 'stars@loverfans.com',
      contact_email_financial: 'financial@artemisa3000.com',
      info_email: 'info@loverfans.com',
      payments_imprint: {
        company: 'Inet-Cash GmbH',
        address: 'Am Stadtbad 14',
        city: '59065 Hamm',
        country: 'Germany',
        contact: {
          phone: 'Tel: +49 (2381) 338-9860',
          fax: 'Fax: +49 (2381) 338-9861',
          email: 'Email: support@inet-cash.com'
        }
      }
    },
    yoti: {
      url: 'https://api.yoti.com/idverify/v1/web/index.html'
    },
    google: {
      oauth: {
        enabled: false,
        client_id:
          '6243420342-deqr1irso0eiou0t8jh39goctgaldceq.apps.googleusercontent.com'
      },
      analytics: {
        id: 'G-VRCGT887VF'
      }
    },
    gtm: 'GTM-KLTN4DF',
    analytics: {
      ga: 'G-VRCGT887VF'
    },
    showFooterImages: false
  },
  scatbook: {
    project: 'scatbook',
    acronym: 'DF',
    primary_color: '#B0601E',
    background_color: '#2d3237',
    promotion: false,
    isDevelop: false,
    redirect_new_frontend: false,
    resources: {
      component: 'ScatbookBanner',
      downloadResourceComponent: 'ScatbookDownloadResourceView',
      promotion_resources: true,
      normal_resources: true,
      downloadableResource: true
    },
    enable_resources: true,
    show_footer: false,
    show_imprint: 'https://scatbook.com/scatbook_imprint',
    enable_themes: false,
    twitter_enabled: true,
    twitter: 'SCATBOOKSOCIAL',
    instagram: 'scatbook_official',
    theme: 'dark',
    multicurrency: false,
    domains: {
      baseUrl: 'https://scatbook.com',
      api: 'https://api.scatbook.com/api',
      websocket: 'wss://ws.scatbook.com'
    },
    payments: {
      darkfans_redirect: true,
      provider: 'inetcash'
    },
    specialOffer: {
      active: false,
      startDate: new Date(2024, 9, 30, 9, 0, 0),
      endDate: new Date(2024, 10, 5, 9, 0, 0),
      discount: 20
    },
    campaign: {
      name: 'san_valentine_2025',
      fileName: 'valentine',
      specialName: 'Happy Valentine’s Day',
      cookieModal: 'hiddenModalCampaignValentine',
      users: ['CpPrueba01', 'CpPrueba02', 'CpPrueba03', 'CpPrueba04', 'CpStarPrueba05', 'CpStarPrueba06', 'CpStarPrueba07', 'CpStarPrueba08'],
      // enero es el mes 00
      started: new Date(2025, 1, 11, 8, 0, 0),
      endDate: new Date(2025, 1, 18, 8, 0, 0),
      post: true,
      specialEnabled: true,
      titleBanner_es: '❤️ FELIZ SAN VALENTIN ❤️',
      titleBanner_en: '❤️ HAPPY VALENTINE’S DAY ❤️',
      descriptionBanner_es: 'Recibe un bono en tu wallet del 30% de tus suscripciones',
      descriptionBanner_en: 'Get a 30% bonus in your wallet on your new subscriptions',
      colorBgBanner: '#DF3856'
    },
    locales: {
      project: 'Scatbook',
      project_upper: 'SCATBOOK',
      site: 'scatbook.com',
      contact_email: 'soporte@scatbook.com',
      contact_email_creator: 'stars@scatbook.com',
      contact_email_financial: 'financial@artemisa3000.com',
      info_email: 'info@scatbook.com',
      payments_imprint: {
        company: 'Inet-Cash GmbH',
        address: 'Am Stadtbad 14',
        city: '59065 Hamm',
        country: 'Germany',
        contact: {
          phone: 'Tel: +49 (2381) 338-9860',
          fax: 'Fax: +49 (2381) 338-9861',
          email: 'Email: support@inet-cash.com'
        }
      }
    },
    yoti: {
      url: 'https://api.yoti.com/idverify/v1/web/index.html'
    },
    google: {
      oauth: {
        enabled: false,
        client_id:
          '929669038588-sirbfabk6gkorjoukmf47epuqca9ten6.apps.googleusercontent.com'
      },
      analytics: {
        id: 'G-NS8GX1QVXH'
      }
    },
    gtm: 'GTM-MMHXVCP',
    analytics: {
      ga: 'G-NS8GX1QVXH'
    },
    showFooterImages: true
  },
  darkfans: {
    project: 'darkfans',
    acronym: 'DF',
    primary_color: '#FF0036',
    background_color: '#292929',
    promotion: false,
    isDevelop: false,
    redirect_new_frontend: false,
    resources: {
      component: 'DarkfansBanner',
      downloadResourceComponent: 'DarkfansDownloadResourceView',
      promotion_resources: true,
      normal_resources: true,
      downloadableResource: true
    },
    enable_resources: true,
    show_footer: false,
    enable_themes: false,
    landing_widget: 'SlaveWidget',
    twitter_enabled: true,
    twitter: 'Darkfans_com',
    instagram: 'darkfans_official',
    theme: 'dark',
    multicurrency: false,
    domains: {
      baseUrl: 'https://darkfans.com',
      api: 'https://api.darkfans.com/api',
      websocket: 'wss://ws.scatbook.com'
    },
    payments: {
      provider: 'inetcash'
    },
    specialOffer: {
      active: false,
      startDate: new Date(2024, 9, 30, 9, 0, 0),
      endDate: new Date(2024, 10, 5, 9, 0, 0),
      discount: 20
    },
    campaign: {
      name: 'san_valentine_2025',
      fileName: 'valentine',
      specialName: 'Happy Valentine’s Day',
      cookieModal: 'hiddenModalCampaignValentine',
      users: ['CpPrueba01', 'CpPrueba02', 'CpPrueba03', 'CpPrueba04', 'CpStarPrueba05', 'CpStarPrueba06', 'CpStarPrueba07', 'CpStarPrueba08'],
      // enero es el mes 00
      started: new Date(2025, 1, 11, 8, 0, 0),
      endDate: new Date(2025, 1, 18, 8, 0, 0),
      post: true,
      specialEnabled: true,
      titleBanner_es: '❤️ FELIZ SAN VALENTIN ❤️',
      titleBanner_en: '❤️ HAPPY VALENTINE’S DAY ❤️',
      descriptionBanner_es: 'Recibe un bono en tu wallet del 30% de tus suscripciones',
      descriptionBanner_en: 'Get a 30% bonus in your wallet on your new subscriptions',
      colorBgBanner: '#DF3856'
    },
    locales: {
      project: 'Darkfans',
      project_upper: 'DARKFANS',
      site: 'darkfans.com',
      contact_email: 'soporte@darkfans.com',
      contact_email_creator: 'stars@darkfans.com',
      contact_email_financial: 'financial@artemisa3000.com',
      info_email: 'info@darkfans.com'
    },
    yoti: {
      url: 'https://api.yoti.com/idverify/v1/web/index.html'
    },
    google: {
      oauth: {
        enabled: false,
        client_id:
          '929669038588-sirbfabk6gkorjoukmf47epuqca9ten6.apps.googleusercontent.com'
      },
      analytics: {
        id: 'G-M8PCQM5VV4'
      }
    },
    gtm: 'GTM-PL837WZ',
    analytics: {
      ga: 'G-M8PCQM5VV4'
    },
    showFooterImages: true
  },
  new_develop: {
    project: 'new_loverfans',
    acronym: 'LF',
    primary_color: '#DF3856',
    background_color: '#2d3237',
    promotion: true,
    isDevelop: false,
    redirect_new_frontend: true,
    resources: {
      component: 'LoverfansBanner',
      downloadResourceComponent: 'LoverfansDownloadResourceView',
      promotion_resources: true,
      normal_resources: true,
      downloadableResource: true
    },
    enable_resources: true,
    show_footer: true,
    show_imprint: 'https://loverfans.com/loverfans_imprint',
    enable_themes: true,
    enable_scat_modal: true,
    twitter_enabled: true,
    twitter: 'loverfans',
    instagram: 'loverfans',
    multicurrency: true,
    domains: {
      baseUrl: 'https://new.loverfans.com',
      api: 'https://api.loverfans.com/api',
      websocket: 'wss://ws.loverfans.com'
    },
    payments: {
      darkfans_redirect: false,
      provider: 'commercegate'
    },
    specialOffer: {
      active: false,
      startDate: new Date(2024, 9, 30, 9, 0, 0),
      endDate: new Date(2024, 10, 5, 9, 0, 0),
      discount: 20
    },
    campaign: {
      name: 'san_valentine_2025',
      fileName: 'valentine',
      specialName: 'Happy Valentine’s Day',
      cookieModal: 'hiddenModalCampaignValentine',
      users: ['CpPrueba01', 'CpPrueba02', 'CpPrueba03', 'CpPrueba04', 'CpStarPrueba05', 'CpStarPrueba06', 'CpStarPrueba07', 'CpStarPrueba08'],
      // enero es el mes 00
      started: new Date(2025, 1, 11, 8, 0, 0),
      endDate: new Date(2025, 1, 18, 8, 0, 0),
      post: true,
      specialEnabled: true,
      titleBanner_es: '❤️ FELIZ SAN VALENTIN ❤️',
      titleBanner_en: '❤️ HAPPY VALENTINE’S DAY ❤️',
      descriptionBanner_es: 'Recibe un bono en tu wallet del 30% de tus suscripciones',
      descriptionBanner_en: 'Get a 30% bonus in your wallet on your new subscriptions',
      colorBgBanner: '#DF3856'
    },
    locales: {
      project: 'Loverfans',
      project_upper: 'LOVERFANS',
      site: 'new.loverfans.com',
      contact_email: 'soporte@loverfans.com',
      contact_email_creator: 'stars@develop-loverfans.com',
      contact_email_financial: 'financial@artemisa3000.com',
      info_email: 'info@loverfans.com',
      payments_imprint: {
        company: 'Inet-Cash GmbH',
        address: 'Am Stadtbad 14',
        city: '59065 Hamm',
        country: 'Germany',
        contact: {
          phone: 'Tel: +49 (2381) 338-9860',
          fax: 'Fax: +49 (2381) 338-9861',
          email: 'Email: support@inet-cash.com'
        }
      }
    },
    yoti: {
      url: 'https://api.yoti.com/idverify/v1/web/index.html'
    },
    google: {
      oauth: {
        enabled: true,
        client_id:
          '6243420342-deqr1irso0eiou0t8jh39goctgaldceq.apps.googleusercontent.com'
      }
      /* analytics: {
        id: 'UA-153181968-1'
      } */
    },
    gtm: 'GTM-WZ49T7G',
    analytics: {
      ga: 'GTM-WZ49T7G'
    },
    showFooterImages: false
  }

}

module.exports = ProjectConfig[process.env.VUE_APP_PROJECT || 'develop']
